import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { deleteContentRequest, deleteContentRequestError, deleteContentRequestSuccess } from "../../slices/content-management/DeleteContentSlice";

export const DeleteContentAPI = (id) => {

    return async (dispatch) => {
        try {
            dispatch(deleteContentRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.deleteContent,
                data: { postId: id },
            })
            return dispatch(deleteContentRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(deleteContentRequestError(_error));
        }
    };
};
